import { takeEvery, put, call } from 'redux-saga/effects';
import { models } from 'powerbi-client';

import * as types from './coverageGapToolEncoreActionType';
import * as actions from './coverageGapToolEncoreActions';
import * as services from './coverageGapToolEncoreServices';

function* fetchCoverageGapToolEncorePowerBIReportSaga() {
    const environment = window.configuration.ENVIRONMENT || 'dev';
    const sharedReport = window.configuration.PowerBI_Reports?.CoverageGapTool?.sharedReport;
    const environmentModelConfig = window.configuration.PowerBI_Reports?.CoverageGapTool?.environmentModelConfig?.[environment];

    if (!sharedReport || !environmentModelConfig) {
        console.error('No Power BI report configured for environment:', environment);
        yield put(actions.fetchCoverageGapToolEncorePowerBIReportFailure('No Power BI report configured for this environment'));
        return;
    }

    const { reportId, reportWorkspaceId, goldenModelId } = sharedReport;
    const { modelId: targetModelId, modelWorkspaceId: targetModelWorkspaceId } = environmentModelConfig;

    try {
        const response = yield call(services.getCoverageGapToolEncorePowerBIToken);

        const embedPayload = {
            token: response?.access_token,
            reportId,
            workspaceId: reportWorkspaceId
        }
        const embedResponse = yield call(services.getCoverageGapToolEncoreEmbedResponse, embedPayload);
        const tokenResponse = yield call(services.getCoverageGapToolEncoreMultiResourceTokenResponse, {
            token: response?.access_token,
            reportId,
            goldenDatasetId: goldenModelId,
            datasetId: targetModelId,
            reportWorkspaceId,
            datasetWorkspaceId: targetModelWorkspaceId
        });

        const embedConfig = {
            type: "report",
            id: reportId,
            embedUrl: embedResponse?.embedUrl,
            accessToken: tokenResponse?.token,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.Read,
            datasetBinding: {
                datasetId: targetModelId
            },
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true
            }
        };

        yield put(actions.fetchCoverageGapToolEncorePowerBIReportSuccess(embedConfig));
    } catch (error) {
        console.error('Coverage Gap Tool Encore PowerBI API Error:', error);
        yield put(actions.fetchCoverageGapToolEncorePowerBIReportFailure('Failed to fetch PowerBI report'));
    }
}

function* fetchCoverageGapToolEncoreLastRefreshedSaga() {
    try {
        const response = yield call(services.getCoverageGapToolLastRefreshed);
        const lastRefreshedDateTime = response?.values?.LastRefreshedDateTime;
        const nextRefreshDateTime = response?.values?.NextRefreshDateTime ?? null;
        const capacityTableReportName = response?.values?.CapacityTableReportName || null;

        if (response?.success !== true || response?.values?.ExceptionId || !lastRefreshedDateTime) {
            throw new Error(response?.errorMessage || 'Failed to fetch Coverage Gap Tool refresh date');
        }

        yield put(actions.fetchCoverageGapToolEncoreLastRefreshedSuccess(lastRefreshedDateTime, nextRefreshDateTime, capacityTableReportName));
    } catch (error) {
        console.error('Coverage Gap Tool Last Refreshed API Error:', error);
        yield put(actions.fetchCoverageGapToolEncoreLastRefreshedFailure('Failed to fetch refresh date'));
    }
}

export default function* coverageGapToolEncoreSaga() {
    yield takeEvery(types.FETCH_COVERAGE_GAP_TOOL_ENCORE_POWER_BI_REPORT_REQUEST, fetchCoverageGapToolEncorePowerBIReportSaga);
    yield takeEvery(types.FETCH_COVERAGE_GAP_TOOL_ENCORE_LAST_REFRESHED_REQUEST, fetchCoverageGapToolEncoreLastRefreshedSaga);
}
